<template>
  <div class="line contPadding">
    <div class="main-title">角色管理</div>
    <el-row class="content-container">
      <div class="search">
        <el-form ref="queryParams" :model="queryParams" label-width="80px">
          <el-input
            v-model="queryParams.roleName"
            placeholder="请输入角色名称"
          ></el-input>
          <el-button type="primary" @click="querySubmit">查询</el-button>
        </el-form>
      </div>
      <el-button type="primary" class="changeBtn" @click="Add">新增</el-button>
      <el-table :data="entList" style="width: 100%">
        <el-table-column label="序号" type="index" width="180" />
        <el-table-column prop="roleName" label="角色名称" />
        <el-table-column prop="roleStatus" label="角色状态">
          <template slot-scope="scope">
            <span>{{ scope.row.roleStatus === '1' ? '正常' : '停用' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope" fixed="right">
            <el-button
              type="text"
              style="font-size: 12px"
              @click="handleEdit(scope.row)"
              >修改</el-button
            >
            <el-button
              type="text"
              style="font-size: 12px"
              @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :current-page.sync="currentPage"
        :page-sizes="pageSizes"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-row>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogFormVisible"
      @close="resetForm('ruleForm')"
      width="850px"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        class="demo-ruleForm"
        label-width="80px"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="角色名称" prop="roleName">
              <el-input
                v-model="ruleForm.roleName"
                placeholder="请输入角色名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="编码" prop="roleCode">
              <el-input
                v-model="ruleForm.roleCode"
                placeholder="请输入编码名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="角色状态" prop="roleStatus">
              <el-select v-model="ruleForm.roleStatus" placeholder="正常">
                <el-option label="正常" value="1"></el-option>
                <el-option label="停用" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="菜单授权">
              <div class="custom-tree-container">
                <el-tree
                  :data="dataTree"
                  :props="defaultProps"
                  show-checkbox
                  ref="tree"
                  node-key="id"
                  default-expand-all
                  :default-checked-keys="keys"
                ></el-tree>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm('ruleForm')">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import paginationMixin from 'mixin/pagination';
export default {
  data() {
    return {
      dialogTitle: '添加角色',
      keys: [],
      entList: [],
      queryParams: {
        roleName: ''
      },
      dataTree: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      dialogFormVisible: false,
      ruleForm: {
        roleName: '',
        roleStatus: '1',
        roleCode: '',
        roleMenus: ''
      },
      rules: {
        roleName: [
          { required: true, message: '请输入角色名称', trigger: 'blur' }
        ],
        roleCode: [
          { required: true, message: '请输入编码名称', trigger: 'blur' }
        ],
        roleStatus: [
          { required: true, message: '请输入角色状态', trigger: 'blur' }
        ]
      }
    };
  },
  mixins: [paginationMixin],
  mounted() {
    this.querySubmit();
  },
  methods: {
    // 查询table数据
    querySubmit() {
      this.$request({
        url: 'rest/bsp/role/loadRoles',
        data: {
          roleName: this.queryParams.roleName,
          pageNum: this.currentPage,
          pageSize: this.pageSize
        }
      }).then(res => {
        this.entList = res.list ? [...res.list] : [];
        this.total = res.total || 0;
      });
    },
    // 弹窗加载角色树
    loadMenu() {
      this.$request({
        url: 'rest/bsp/pubMenu/loadMenu'
      }).then(res => {
        this.dataTree = res ? [...res] : [];
      });
    },
    // 修改
    handleEdit(row) {
      this.dialogTitle = '修改角色';
      this.$request({
        url: 'rest/bsp/role/loadRoleById/' + row.id,
        method: 'get'
      }).then(res => {
        this.ruleForm.roleStatus = res.roleStatus;
        this.roleid = res.id;
        this.ruleForm.roleName = res.roleName;
        this.ruleForm.roleCode = res.roleCode;
        this.ruleForm.roleMenus = res.roleMenus;
        this.$request({
          url: 'rest/bsp/pubMenu/loadMenu'
        }).then(response => {
          this.dataTree = response ? [...response] : [];
          const allLastMenu = this.getLastLevelNodes(this.dataTree, []);
          let keys = [];
          if (res.roleMenus.indexOf(',') > -1) {
            keys = res.roleMenus.split(',').filter(item => {
              return allLastMenu.indexOf(item) > -1;
            });
          }
          this.keys = keys;
          this.dialogFormVisible = true;
        });
      });
    },
    Add() {
      this.dialogTitle = '添加角色';
      this.dialogFormVisible = true;
      this.ruleForm.roleName = '';
      this.ruleForm.roleCode = '';
      this.ruleForm.roleStatus = '';
      this.loadMenu();
      this.$refs.tree && this.$refs.tree.setCheckedKeys([]);
    },
    // 提交弹窗Form表单
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.ruleForm.roleMenus = this.getAllCheckedNodes();
          const obj = {
            baseInfo: {
              id: this.roleid,
              roleName: this.ruleForm.roleName,
              roleStatus: this.ruleForm.roleStatus,
              roleCode: this.ruleForm.roleCode,
              roleMenus: this.ruleForm.roleMenus
            }
          };
          this.$request({
            url: 'rest/bsp/role/mergeRole',
            data: {
              json: JSON.stringify(obj)
            }
          }).then(res => {
            this.dialogFormVisible = false;

            this.$message({
              message: this.roleid ? '修改角色成功' : '新增角色成功',
              type: 'success'
            });
            this.querySubmit();
          });
        } else {
          return false;
        }
      });
    },
    handleDelete(row) {
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$request({
          url: 'rest/bsp/role/deleteRoleById/' + row.id
        }).then(res => {
          this.dialogFormVisible = false;
          this.$message({
            message: '成功删除角色',
            type: 'success'
          });
          this.querySubmit();
        });
      });
    },
    // 关闭清空数据
    resetForm(formName) {
      this.dialogFormVisible = false;
      this.$refs[formName].resetFields();
      // this.$refs.tree.setCheckedKeys([])
    },
    // 获取所有被选中的节点（包括半选状态的父节点）
    getAllCheckedNodes() {
      const checkedNodes = this.$refs.tree.getCheckedNodes();
      const halfCheckedNodes = this.$refs.tree.getHalfCheckedNodes();
      const allCheckedNodes = checkedNodes.concat(halfCheckedNodes);
      const arr = [];
      allCheckedNodes.forEach(item => {
        arr.push(item.id);
      });
      return arr.join(',');
    },
    // 获取所有角色中的最末级角色
    getLastLevelNodes(roleData, lastLevelArr) {
      roleData.forEach(item => {
        if (item.children && item.children.length > 0) {
          this.getLastLevelNodes(item.children, lastLevelArr);
        } else {
          lastLevelArr.push(item.id);
        }
      });
      return lastLevelArr;
    }
  }
};
</script>
<style lang="stylus" scoped>
@import './common.styl'
.changeBtn
  margin 10px 20px 10px 0
  float right
  cursor pointer
.container
  .submit
    float left
i
  cursor pointer
  font-style normal
  font-weight normal
  display inline-block
  background #39be6b
  border-radius 3px
  padding 2px 3px
  font-size 10px
  color #fff
  text-align center
.Delete
  background #ee3c0c
.search
  width 300px
  position relative
  margin-top 30px
  padding-left 20px
  .el-input
    position absolute
    left 20px
    top 0
    width 200px
  .el-button
    position absolute
    top 0
    right 0
.custom-tree-container
  margin-top 5px
.pagination
  padding 20px
  background #fff
  text-align right
</style>
